import {
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonMenuButton,
    IonPage,
    IonRefresher,
    IonRefresherContent,
    IonSegment,
    IonSegmentButton,
    IonLabel,
    IonTitle,
    IonToolbar,
    RefresherEventDetail
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { arrowForward, chevronDownCircleOutline, logoEuro, sad, flag } from "ionicons/icons";
import createAxiosInstance from "../../services/AxiosInstance";
import './PersonalStats.css'
import { DertigenStatistic } from "../../model/DertigenStatistic";
import { User } from "../../model/User";
import { Link, useLocation } from "react-router-dom";
import PercentageChart from "../../components/stats/PercentageChart";
import LoadingSpinner from "../../components/shared/LoadingSpinner";
import ProfilePicture from "../../components/shared/ProfilePicture";
import ErrorMessage from "../../components/shared/ErrorMessage";
import AddTransactionPopover from "../../components/transactions/AddTransactionPopOver";
import Dashboard from "../../components/Dashboard";
import PresenceHeatmap from "../../components/presence/presence_heat_map/PresenceHeatmap";
import { useToast } from "../../utils/useToasts";
import {getPushNotificationsStatus, PushNotificationsStatus} from "../../services/pushNotifications";

const HTTP_OK_STATUS = 200;
const PROFILE_PICTURE_SIZE = 100;
const COMPACT_HEATMAP_CELL_SIZE = 8;
const DEFAULT_HEATMAP_CELL_SIZE = 20;
const DEFAULT_HEATMAP_GAP = 4;
const PERCENTAGE_MULTIPLIER = 100;
const WEEKLY_STRIPE_GOAL = 400;
const YEARLY_STRIPE_GOAL = 35_000;

const INITIAL_PUSH_STATUS: PushNotificationsStatus = {
    isSupported: false,
    hasFirebaseConfig: false,
    permission: 'unsupported',
    hasStoredToken: false,
};

const toPercentage = (ratio: number) => ratio * PERCENTAGE_MULTIPLIER;

const shouldShowPushAccountWarning = (status: PushNotificationsStatus): boolean => {
    return status.isSupported && status.hasFirebaseConfig && (status.permission !== 'granted' || !status.hasStoredToken);
};

const getPushAccountWarningMessage = (status: PushNotificationsStatus): string => {
    if (status.permission === 'denied') {
        return 'Je hebt pushmeldingen voor dit apparaat geblokkeerd. Ga naar Mijn account om pushmeldingen te beheren en dit apparaat opnieuw te registreren.';
    }

    if (status.permission === 'granted' && !status.hasStoredToken) {
        return 'Dit apparaat is nog niet geregistreerd voor pushmeldingen. Ga naar Mijn account en koppel dit apparaat.';
    }

    return 'Je hebt nog geen toestemming gegeven voor pushmeldingen op dit apparaat. Ga naar Mijn account om dit apparaat te registreren.';
};

const PersonalStats: React.FC = () => {

    const location = useLocation();
    const [person, setPerson] = useState<User>();
    const [dertigenStatistic, setDertigenStatistic] = useState<DertigenStatistic>();
    const [amountOfEvenings, setAmountOfEvenings] = useState<number>();
    const [selectedPage, setSelectedPage] = useState<string>("personal-stats");
    const showToasts = useToast();
    const axios = createAxiosInstance();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isLoadingDerigen, setIsLoadingDertigen] = useState<boolean>(true);
    const [profilePicFile, setProfilePicFile] = useState(null);
    const [profilePicUrl, setProfilePicUrl] = useState('');
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [compact, setCompact] = useState(false);
    const [pushStatus, setPushStatus] = useState<PushNotificationsStatus>(INITIAL_PUSH_STATUS);

    const doRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        setIsLoading(true)
        setIsLoadingDertigen(true)
        fetchPeronalData()
        fetchEveningsCount()
        fetchDertigenStatisticsData()
        event.detail.complete();
    }

    const handleFileChange = (event: any) => {
        const file = event.target.files[0];
        if (file) {
            setProfilePicFile(file);
            uploadProfilePic(file);
        }
    };

    const uploadProfilePic = (file: any) => {
        const formData = new FormData();
        formData.append('avatar', file || profilePicFile);

        axios.post(`/user/profile-picture`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then(response => {
                setProfilePicUrl(response.data.filePath);
                showToasts('Profiel foto succesvol geupload', 'success');
            })
            .catch(error => {
                console.error('Error uploading profile picture:', error);
                showToasts('Failed to upload profile picture.', 'danger');
            });
    };


    function fetchPeronalData() {
        axios.get('/user/personal-data/header')
            .then(res => {
                setPerson(res.data)
                if (res.data.profilePictureUrl) {
                    setProfilePicUrl(res.data.profilePictureUrl);
                }
                setIsLoading(false);
            }).catch((error) => {
                console.error('Error fetching person data:', error);
                setIsLoading(false);
            });
    }

    function fetchDertigenStatisticsData() {
        axios.get('/user/dertigen/statistics')
            .then(res => {
                setDertigenStatistic(res.data)
                console.log(res.data)
                setIsLoadingDertigen(false);
            }).catch((error) => {
                console.error('Error fetching person data:', error);
                setIsLoadingDertigen(false);
            });
    }

    function fetchEveningsCount() {
        axios.get('/evening/')
            .then(res => {
                setAmountOfEvenings(res.data.count)
            }).catch((error) => {
                console.log(error)
            });
    }

    const addPuke = () => {
        axios.post('/barf')
            .then(() => {
                showToasts("Je hebt gekotst!", 'success')
                fetchPeronalData();
            })
            .catch(err => {
                console.error(err)
                showToasts('Er is iets mis gegaan', 'danger')
            })
    }

    const addMollieTransaction = (amount: number) => {
        axios.post('/transactions/mollie/create-transaction', {
            amount,
        })
            .then(response => {
                if (response.status === HTTP_OK_STATUS) {
                    window.location.href = response.data;
                } else {
                    showToasts('Er is iets mis gegaan', 'danger')
                }
            })
            .catch(err => {
                console.error(err)
                showToasts('We konden geen verbinding maken met Mollie, probeer het nogmaals', 'danger')
            })
    }

    const addTransaction = () => {
        setIsPopoverOpen(true);
    };

    const handlePopoverSubmit = (amount: number) => {
        addMollieTransaction(amount);
    };

    function callKeet() {
        axios.post('/call/')
            .then(() =>
                showToasts("Keet gebeld", 'success')
            ).catch((err) => {
                console.error(err);
                showToasts("Keet nam niet op ofzo", 'danger')
            })
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const pageParam = searchParams.get("page");

        if (pageParam === "dashboard") {
            setSelectedPage("dashboard");
        }

        fetchPeronalData()
        fetchEveningsCount()
        fetchDertigenStatisticsData()
    }, [location.search])

    useEffect(() => {
        const mq = window.matchMedia("(max-width: 560px)");
        const apply = () => setCompact(mq.matches);
        apply();
        mq.addEventListener("change", apply);
        return () => mq.removeEventListener("change", apply);
    }, []);

    useEffect(() => {
        getPushNotificationsStatus()
            .then(setPushStatus)
            .catch((error) => {
                console.warn('[Push] Status ophalen mislukt op homepagina.', error);
            });
    }, []);


    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>Welkom {person?.name}</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen class={'personal-stats-content'}>
                <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent
                        pullingIcon={chevronDownCircleOutline}
                        refreshingSpinner="circles"
                        refreshingText="Verversen..."
                    />
                </IonRefresher>
                {person?.roles && person.roles.includes('user') && (
                    <IonSegment
                        mode="ios"
                        defaultValue="personal-stats"
                        className="page-selector"
                        value={selectedPage}
                        onIonChange={(e) => e.detail.value && setSelectedPage(e.detail.value as string)}
                    >
                        <IonSegmentButton value="personal-stats">
                            <IonLabel>Mijn statistieken</IonLabel>
                        </IonSegmentButton>
                        <IonSegmentButton value="dashboard">
                            <IonLabel>Dashboard</IonLabel>
                        </IonSegmentButton>
                    </IonSegment>
                )}

                {selectedPage === "personal-stats" && (
                    <>
                        <ErrorMessage
                            message={"Je account heeft nog geen geregistreerd e-mail adres, hierdoor kan je wachtwoord niet hersteld worden wanneer nodig. Ga alsjeblieft naar 'Mijn Account' en registreer een e-mail adres"}
                            isVisible={person !== undefined && person?.emailAddress === undefined} />
                        <ErrorMessage
                            message={getPushAccountWarningMessage(pushStatus)}
                            isVisible={shouldShowPushAccountWarning(pushStatus)}
                            actionLabel="Mijn account"
                            actionLink="/account-settings"
                        />
                        <IonCard>
                            <IonCardHeader>
                                <IonTitle>Mijn profiel</IonTitle>
                            </IonCardHeader>
                            <IonCardContent className={'centered-profile-pic'}>
                                <IonItem>
                                    <ProfilePicture
                                        profilePicUrl={profilePicUrl.length !== 0 ? `${process.env.REACT_APP_STORAGE}${profilePicUrl}` : `${process.env.REACT_APP_STORAGE}default-profile.jpg`}
                                        onFileChange={handleFileChange}
                                        showEditable={true} width={PROFILE_PICTURE_SIZE} height={PROFILE_PICTURE_SIZE}
                                        fullName={person?.name ? person?.name : 'A'}
                                    />
                                </IonItem>
                            </IonCardContent>
                        </IonCard>
                        {person?.blackList && (
                            <IonCard>

                                <IonCardHeader className="custom-card-header">Zwarte lijst</IonCardHeader>
                                <IonCardContent className="custom-card-content">
                                    <IonIcon color="black" icon={flag} className="blacklist-flag-icon"></IonIcon>
                                    <p>Je staat op de zwarte lijst</p>
                                </IonCardContent>

                            </IonCard>
                        )}
                        <IonCard>
                            <IonCardHeader>
                                <IonTitle>Aanwezigheids heatmap</IonTitle>
                            </IonCardHeader>
                            <IonCardContent className={'centered-profile-pic'}>
                                {person?.datesPresent !== undefined && (
                                    <div className="heatmap-card">
                                        <PresenceHeatmap
                                            attendanceDates={person?.datesPresent}
                                            compact={compact}
                                            showWeekdayLabels
                                            cellSize={compact ? COMPACT_HEATMAP_CELL_SIZE : DEFAULT_HEATMAP_CELL_SIZE}
                                            gap={compact ? 2 : DEFAULT_HEATMAP_GAP}
                                        />
                                    </div>
                                )}
                            </IonCardContent>
                        </IonCard>
                        {(person?.roles?.includes('user') || person?.roles?.includes('regular-guest')) && (
                            <>
                                <IonCard>
                                    <IonCardHeader>
                                        <IonTitle>Financieel</IonTitle>
                                    </IonCardHeader>
                                    {isLoading ? (
                                        <IonCardContent className="spinner-grid">
                                            <div className="spinner-container">
                                                <LoadingSpinner />
                                            </div>
                                        </IonCardContent>
                                    ) : (
                                        <IonCardContent className={'custom-grid'}>
                                            <div className="custom-card">
                                                <IonCardHeader className="custom-card-header">Saldo</IonCardHeader>
                                                <IonCardContent className="custom-card-content">
                                                    <p>€{person?.balance},-</p>
                                                </IonCardContent>
                                            </div>
                                            <div className="custom-card">
                                                <IonCardHeader
                                                    className="custom-card-header">Uitgegeven</IonCardHeader>
                                                <IonCardContent className="custom-card-content">
                                                    <p>€{person?.expense},-</p>
                                                </IonCardContent>
                                            </div>
                                            <div className="custom-card">
                                                <IonCardHeader
                                                    className="custom-card-header">Opwaarderen met
                                                    Mollie</IonCardHeader>
                                                <IonCardContent className="custom-card-content">
                                                    <IonButton className={'pay-for-balance-button'}
                                                        onClick={addTransaction}>
                                                        <IonIcon icon={logoEuro}></IonIcon>
                                                    </IonButton>
                                                </IonCardContent>
                                            </div>
                                        </IonCardContent>
                                    )}
                                </IonCard>
                                <IonCard>
                                    <IonCardHeader>
                                        <IonTitle>
                                            <div className={'presence-card-title'}>
                                                Aanwezigheid
                                                <Link style={{ textDecoration: 'none' }}
                                                    to={`/presence/${person?.id}`}>
                                                    <IonButton className={'route-evenings-button'} shape={'round'}>
                                                        <IonIcon icon={arrowForward}></IonIcon>
                                                    </IonButton>
                                                </Link>
                                            </div>
                                        </IonTitle>
                                    </IonCardHeader>
                                    {isLoading ? (
                                        <IonCardContent className="spinner-grid">
                                            <div className="spinner-container">
                                                <LoadingSpinner />
                                            </div>
                                        </IonCardContent>
                                    ) : (
                                        <IonCardContent class={'custom-grid'}>
                                            <>
                                                <div className="custom-card">
                                                    <IonCardHeader className="custom-card-header">Hoevaak
                                                        aanwezig</IonCardHeader>
                                                    <IonCardContent className="custom-card-content">
                                                        <p>{person?.amountOfEvenings}</p>
                                                    </IonCardContent>
                                                </div>
                                            </>
                                            {person && amountOfEvenings && (
                                                <div className="custom-card">
                                                    <IonCardHeader className="custom-card-header">% van alle
                                                        avonden</IonCardHeader>
                                                    <IonCardContent className="custom-percentage-card-content">
                                                        <p>{(toPercentage(person?.amountOfEvenings !== undefined ? person?.amountOfEvenings / amountOfEvenings : 0).toFixed(2))}%
                                                        </p>
                                                        <div className={'percentage-component'}>
                                                            <PercentageChart
                                                                percentage={toPercentage(person?.amountOfEvenings !== undefined ? person?.amountOfEvenings / amountOfEvenings : 0)}></PercentageChart>
                                                        </div>
                                                    </IonCardContent>
                                                </div>
                                            )}
                                        </IonCardContent>
                                    )}
                                </IonCard>
                                <IonCard>
                                    <IonCardHeader>
                                        <IonTitle>Barry</IonTitle>
                                    </IonCardHeader>
                                    {isLoading ? (
                                        <IonCardContent className="spinner-grid">
                                            <div className="spinner-container">
                                                <LoadingSpinner />
                                            </div>
                                        </IonCardContent>
                                    ) : (
                                        <IonCardContent class={'custom-grid'}>
                                            <div className="custom-card">
                                                <IonCardHeader className="custom-card-header">Hoevaak
                                                    genekt</IonCardHeader>
                                                <IonCardContent className="custom-card-content">
                                                    <p>{person?.amountOfPukes}</p>
                                                </IonCardContent>
                                            </div>
                                            <div className="custom-card">
                                                <IonCardHeader className="custom-card-header">Ik heb
                                                    gekotst</IonCardHeader>
                                                <IonCardContent className="custom-card-content">
                                                    <IonButton onClick={addPuke}>
                                                        Genekt
                                                        <IonIcon icon={sad}></IonIcon>
                                                    </IonButton>
                                                </IonCardContent>
                                            </div>
                                        </IonCardContent>
                                    )}
                                </IonCard>
                            </>
                        )}
                        <IonCard>
                            <IonCardHeader>
                                <IonTitle>Doelstellingen</IonTitle>
                            </IonCardHeader>
                            {isLoadingDerigen ? (
                                <IonCardContent className="spinner-grid">
                                    <div className="spinner-container">
                                        <LoadingSpinner />
                                    </div>
                                </IonCardContent>
                            ) : (
                                <IonCardContent className="custom-grid">
                                    {dertigenStatistic && (
                                        <>
                                            <div className="custom-card">
                                                <IonCardHeader className="custom-card-header">Wekelijks strependoel: {WEEKLY_STRIPE_GOAL}
                                                    strepen</IonCardHeader>
                                                <IonCardContent className="custom-percentage-card-content">
                                                    {dertigenStatistic.gulpsThisWeek >= WEEKLY_STRIPE_GOAL ? (
                                                        <>
                                                            <p>Doel van {WEEKLY_STRIPE_GOAL} strepen bereikt!</p>
                                                            <div className={'percentage-component'}>
                                                                <PercentageChart percentage={PERCENTAGE_MULTIPLIER}></PercentageChart>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <p>{(toPercentage(dertigenStatistic.gulpsThisWeek / WEEKLY_STRIPE_GOAL).toFixed(1))}%</p>
                                                            <p>{dertigenStatistic.gulpsThisWeek} van de {WEEKLY_STRIPE_GOAL}
                                                                gedronken</p>
                                                            <div className={'percentage-component'}>
                                                                <PercentageChart
                                                                    percentage={toPercentage(dertigenStatistic.gulpsThisWeek / WEEKLY_STRIPE_GOAL)}></PercentageChart>
                                                            </div>
                                                        </>
                                                    )}
                                                </IonCardContent>
                                            </div>
                                            <div className="custom-card">
                                                <IonCardHeader className="custom-card-header">Jaarlijks strependoel:
                                                    35.000
                                                    strepen</IonCardHeader>
                                                <IonCardContent className="custom-percentage-card-content">
                                                    {dertigenStatistic.gulpsThisYear >= YEARLY_STRIPE_GOAL ? (
                                                        <>
                                                            <p>Jaarlijks strependoel bereikt!</p>
                                                            <div className={'percentage-component'}>
                                                                <PercentageChart percentage={PERCENTAGE_MULTIPLIER}></PercentageChart>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <p>{(toPercentage(dertigenStatistic.gulpsThisYear / YEARLY_STRIPE_GOAL).toFixed(1))}%</p>
                                                            <p>{dertigenStatistic.gulpsThisYear} van de {YEARLY_STRIPE_GOAL}
                                                                gedronken</p>
                                                            <div className={'percentage-component'}>
                                                                <PercentageChart
                                                                    percentage={toPercentage(dertigenStatistic.gulpsThisYear / YEARLY_STRIPE_GOAL)}></PercentageChart>
                                                            </div>
                                                        </>
                                                    )}
                                                </IonCardContent>
                                            </div>
                                        </>
                                    )}
                                </IonCardContent>
                            )}
                        </IonCard>
                        <IonCard>
                            <IonCardHeader>
                                <IonTitle>Dertigen</IonTitle>
                            </IonCardHeader>
                            {isLoadingDerigen ? (
                                <IonCardContent className="spinner-grid">
                                    <div className="spinner-container">
                                        <LoadingSpinner />
                                    </div>
                                </IonCardContent>
                            ) : (
                                <IonCardContent className="custom-grid">
                                    <>
                                        <div className="custom-card">
                                            <IonCardHeader className="custom-card-header">Jouw
                                                record</IonCardHeader>
                                            <IonCardContent className="custom-card-content">
                                                <p>{dertigenStatistic?.dertigenRecord}</p>
                                            </IonCardContent>
                                        </div>

                                        <div className="custom-card">
                                            <IonCardHeader className="custom-card-header">Laatste
                                                score</IonCardHeader>
                                            <IonCardContent className="custom-card-content">
                                                <p>{dertigenStatistic?.dertigenRecent}</p>
                                            </IonCardContent>
                                        </div>

                                        <div className="custom-card">
                                            <IonCardHeader className="custom-card-header">Strepen per
                                                beurt</IonCardHeader>
                                            <IonCardContent className="custom-card-content">
                                                <p>{dertigenStatistic?.meanThrows}</p>
                                            </IonCardContent>
                                        </div>

                                        <div className="custom-card">
                                            <IonCardHeader className="custom-card-header">Gedronken
                                                strepen</IonCardHeader>
                                            <IonCardContent className="custom-card-content">
                                                <p>{dertigenStatistic?.gulpsPerPlayer}</p>
                                            </IonCardContent>
                                        </div>

                                        <div className="custom-card">
                                            <IonCardHeader className="custom-card-header">Hoeveel
                                                glazen</IonCardHeader>
                                            <IonCardContent className="custom-card-content">
                                                <p>{dertigenStatistic?.glassesPerPlayer}</p>
                                            </IonCardContent>
                                        </div>

                                        <div className="custom-card">
                                            <IonCardHeader className="custom-card-header">Totaal
                                                gezopen</IonCardHeader>
                                            <IonCardContent className="custom-card-content">
                                                <p>{dertigenStatistic?.totalGulps} strepen</p>
                                            </IonCardContent>
                                        </div>
                                        {dertigenStatistic && (
                                            <div className="custom-card">
                                                <IonCardHeader className="custom-card-header">Percentage van
                                                    totaal</IonCardHeader>
                                                <IonCardContent className="custom-percentage-card-content">
                                                    <p>{(toPercentage(dertigenStatistic?.gulpsPerPlayer / dertigenStatistic?.totalGulps).toFixed(2))}%</p>
                                                    <div className={'percentage-component'}>
                                                        <PercentageChart
                                                            percentage={toPercentage(dertigenStatistic?.gulpsPerPlayer / dertigenStatistic?.totalGulps)}></PercentageChart>
                                                    </div>
                                                </IonCardContent>
                                            </div>
                                        )}
                                        <div className="custom-card">
                                            <IonCardHeader className="custom-card-header">Hoevaak
                                                streper</IonCardHeader>
                                            <IonCardContent className="custom-card-content">
                                                <p>{dertigenStatistic?.amountOfTimesStiper}</p>
                                            </IonCardContent>
                                        </div>
                                        {dertigenStatistic && (
                                            <div className="custom-card">
                                                <IonCardHeader className="custom-card-header">Streper per
                                                    lobby</IonCardHeader>
                                                <IonCardContent className="custom-percentage-card-content">
                                                    <p>{(toPercentage(dertigenStatistic?.amountOfTimesStiper / dertigenStatistic?.amountOfLobbies).toFixed(2))}%</p>
                                                    <div className={'percentage-component'}>
                                                        <PercentageChart
                                                            percentage={toPercentage(dertigenStatistic?.amountOfTimesStiper / dertigenStatistic?.amountOfLobbies)}></PercentageChart>
                                                    </div>
                                                </IonCardContent>
                                            </div>
                                        )}
                                        <div className="custom-card">
                                            <IonCardHeader className="custom-card-header">Verdubbelaars</IonCardHeader>
                                            <IonCardContent className="custom-card-content">
                                                <p>{dertigenStatistic?.amountOfDoublers}</p>
                                            </IonCardContent>
                                        </div>
                                        <div className="custom-card">
                                            <IonCardHeader className="custom-card-header">Straatjes
                                                gegooid</IonCardHeader>
                                            <IonCardContent className="custom-card-content">
                                                <p>{dertigenStatistic?.amountOfStreetsThrown}</p>
                                            </IonCardContent>
                                        </div>
                                        <div className="custom-card">
                                            <IonCardHeader className="custom-card-header">Meeste straatjes van
                                                gekregen</IonCardHeader>
                                            <IonCardContent className="custom-card-content">
                                                <p>{dertigenStatistic?.mostStreetsReceivedFrom?.player} - {dertigenStatistic?.mostStreetsReceivedFrom?.amount}</p>
                                            </IonCardContent>
                                        </div>
                                        <div className="custom-card">
                                            <IonCardHeader className="custom-card-header">Meeste straatjes
                                                gegeven</IonCardHeader>
                                            <IonCardContent className="custom-card-content">
                                                <p>{dertigenStatistic?.mostStreetsGivenTo?.player} - {dertigenStatistic?.mostStreetsGivenTo?.amount}</p>
                                            </IonCardContent>
                                        </div>
                                        <div className="custom-card">
                                            <IonCardHeader className="custom-card-header">Telefoon straf</IonCardHeader>
                                            <IonCardContent className="custom-card-content">
                                                <IonButton onClick={() => callKeet()}>Bellen</IonButton>
                                            </IonCardContent>
                                        </div>
                                    </>
                                </IonCardContent>
                            )}
                        </IonCard>
                        <IonCard>
                            <IonCardHeader>
                                <IonTitle>
                                    Contact
                                </IonTitle>
                            </IonCardHeader>
                            <IonCardContent className={'custom-grid'}>
                                <div className="custom-card">
                                    <IonCardHeader className="custom-card-header">Telefoon</IonCardHeader>
                                    <IonCardContent className="custom-card-content">
                                        <p>06-28294256</p>
                                    </IonCardContent>
                                </div>
                                <div className="custom-card">
                                    <IonCardHeader className="custom-card-header">Email-address</IonCardHeader>
                                    <IonCardContent className="custom-card-content">
                                        <p>hethuddje@gmail.com</p>
                                    </IonCardContent>
                                </div>
                            </IonCardContent>
                        </IonCard>
                        <AddTransactionPopover
                            isOpen={isPopoverOpen}
                            onClose={() => setIsPopoverOpen(false)}
                            onSubmit={handlePopoverSubmit}
                            currentBalance={person?.balance}

                        />
                    </>
                )}
                {selectedPage === 'dashboard' && <Dashboard />}
            </IonContent>
        </IonPage >
    );
};

export default PersonalStats;
